import { useMutation } from '@tanstack/react-query';
import type { components } from '@sentinel/api-client';
import { useApi } from '../../lib/api';

export type DiscoverResult = components['schemas']['HrdDiscoverResponse'];

export function useDiscover() {
  const api = useApi();
  return useMutation({
    mutationFn: async (email: string): Promise<DiscoverResult> => {
      const { data, error } = await api.POST('/sso/discover', { body: { email } });
      if (error) throw error;
      return data!;
    },
  });
}
